import { RefObject, useEffect } from 'react';

interface UseInfiniteScrollOptions {
  rootRef: RefObject<HTMLElement>;
  sentinelRef: RefObject<HTMLElement>;
  hasMore: boolean;
  isLoading: boolean;
  onLoadMore: () => void;
  rootMargin?: string;
}

export function useInfiniteScroll({
  rootRef,
  sentinelRef,
  hasMore,
  isLoading,
  onLoadMore,
  rootMargin = '120px',
}: UseInfiniteScrollOptions): void {
  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') return;
    const root = rootRef.current;
    const sentinel = sentinelRef.current;
    if (!root || !sentinel || !hasMore) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting && hasMore && !isLoading) {
          onLoadMore();
        }
      },
      { root, rootMargin },
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [rootRef, sentinelRef, hasMore, isLoading, onLoadMore, rootMargin]);
}
